import React from "react";
import PropTypes from "prop-types";
// import { useStyles } from "./styles";
import ScrollableTabs from "../../../components/TabPanel/index";
import {
  triggerFetchRechargeDistribution,
  triggerRechargeDistributionCsv,
} from "../../../redux/actions/index";

export default function RechargeDistribution(props) {
  const {
    data: {
      secTilesMasterTxDtos: tilesDto = [],
      isSectionActive = "",
      sectionName,
    },
    timeStampArr,
    ...other
  } = props;
  if (isSectionActive === "Y") {
    if (tilesDto.length) {
      return (
        <ScrollableTabs
          sectionHeader={"Recharge " + sectionName}
          section={sectionName}
          tabsDto={tilesDto}
          sortingProperty="tileId"
          sortingOrder="asc"
          tabVariant="fullWidth"
          color="#7caeea"
          triggerFetchRechargeDistribution={triggerFetchRechargeDistribution}
          triggerRechargeDistributionCsv={triggerRechargeDistributionCsv}
          timeStampArr={timeStampArr}
          {...other}
        />
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
}

RechargeDistribution.propTypes = {
  tilesDto: PropTypes.arrayOf(
    PropTypes.shape({
      tileId: PropTypes.number,
      tileName: PropTypes.string,
      isTileActive: PropTypes.string,
      tileEndPointUrl: PropTypes.string,
      moduleSecMasterTransactionDto: PropTypes.any,
    })
  ),
};
